'use client';

import { cva } from 'class-variance-authority';
import { Toaster as Sonner } from 'sonner';

const sonnerToastVariants = cva(
  'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
  {
    variants: {
      variant: {
        default: '',
        success: 'group-[.toaster]:border-success/50 group-[.toaster]:bg-success/10',
        error: 'group-[.toaster]:border-destructive/50 group-[.toaster]:bg-destructive/10',
        warning: 'group-[.toaster]:border-warning/50 group-[.toaster]:bg-warning/10',
        info: 'group-[.toaster]:border-info/50 group-[.toaster]:bg-info/10',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

const sonnerDescriptionVariants = cva('group-[.toast]:text-muted-foreground');
const sonnerActionButtonVariants = cva(
  'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
);
const sonnerCancelButtonVariants = cva(
  'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
);

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const theme = 'system';

  return (
    <Sonner
      theme={theme as 'system' | 'light' | 'dark'}
      className='toaster group'
      toastOptions={{
        classNames: {
          toast: sonnerToastVariants(),
          description: sonnerDescriptionVariants(),
          actionButton: sonnerActionButtonVariants(),
          cancelButton: sonnerCancelButtonVariants(),
        },
      }}
      {...props}
    />
  );
};

export {
  sonnerToastVariants,
  sonnerDescriptionVariants,
  sonnerActionButtonVariants,
  sonnerCancelButtonVariants,
};

export { Toaster };
